<app-index-layout [layoutData]="layoutData">
  <div box-body>
    <div class="multifactor-auth-container-instructions">
      <h2>Multi-factor Authentication</h2>
      <hr />
      <h6>Enter the verification code to complete the login.</h6>
      <p>The code will be sent to your registered email.</p>
    </div>
    <div class="multifactor-auth-container-form">
      <form [formGroup]="authForm" (ngSubmit)="onSubmit()" autocomplete="false">
        <div class="form-group">
          <label *ngIf="showTimer">Verification Code:</label>
          <input
            *ngIf="showTimer"
            type="text"
            [maxLength]="6"
            appOnlyNumbers
            [allowDecimal]="false"
            formControlName="mfaCode"
            class="form-control"
          />
        </div>
        <div class="form-group-buttons">
          <button *ngIf="showTimer" type="submit" class="btn btn-primary w-100 mb-2" [disabled]="authForm.invalid">
            Verify
          </button>
          <button *ngIf="!showTimer" type="button" class="btn btn-primary w-100" (click)="generateMfaCode()">
            Send Verification Code
          </button>
          <div
            class="text-left"
            *ngIf="showTimer"
            matTooltip="Remaining time to resend a new code: {{ countdown || '00:00' }}"
            [matTooltipDisabled]="resendEnabled"
          >
            <button
              type="button"
              class="btn btn-link resend-btn"
              [disabled]="!resendEnabled"
              (click)="generateMfaCode()"
            >
              Resend Code
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="mt-4">
      <hr />
      <a routerLink="/login">Cancel</a>
    </div>
  </div>
</app-index-layout>
